import EventTypeLocation from 'domains/models/event_type_location';
import { z } from 'zod';
import { DisplayTypeEnum, PhoneTypeEnum } from './enum';

export type EventTypeLocationUpdateBody = z.infer<
  typeof schemaEventTypeLocationUpdateBody
>;
export const schemaEventTypeLocationUpdateBody = z.object({
  eventTypeId: z.number().nullable(),
  displayType: DisplayTypeEnum.nullable(),
  isInPerson: z.boolean(),
  access: z.string().nullable(),
  address: z.string().nullable(),
  isZoom: z.boolean(),
  isGoogle: z.boolean(),
  isTeams: z.boolean(),
  isPhone: z.boolean(),
  phoneNumber: z.string().nullable(),
  phoneNumberCountryCode: z.string().nullable(),
  phoneType: PhoneTypeEnum,
  isAskInvitee: z.boolean(),
  isCustom: z.boolean(),
  customLocation: z.string().nullable(),
  sort: z.string().nullable(),
});

export type EventTypeLocationItem = z.infer<typeof schemaEventTypeLocationItem>;
export const schemaEventTypeLocationItem = z.object({
  eventTypeId: z.number(),
  displayType: DisplayTypeEnum.nullable(),
  isInPerson: z.boolean(),
  access: z.string().nullable(),
  address: z.string().nullable(),
  isZoom: z.boolean(),
  isGoogle: z.boolean(),
  isTeams: z.boolean(),
  isPhone: z.boolean(),
  phoneNumber: z.string().nullable(),
  phoneNumberCountryCode: z.string().nullable(),
  phoneType: PhoneTypeEnum,
  isAskInvitee: z.boolean(),
  isCustom: z.boolean(),
  customLocation: z.string().nullable(),
  sort: z.string().nullable(),
  zoomDisconnectedUserId: z.string().nullable(),
  googleDisconnectedUserId: z.string().nullable(),
});

export type EventTypeLocationListItem = z.infer<
  typeof schemaEventTypeLocationListItem
>;
export const schemaEventTypeLocationListItem = z.object({
  eventTypeId: z.number(),
  isInPerson: z.boolean(),
  address: z.string().nullable(),
  isZoom: z.boolean(),
  isGoogle: z.boolean(),
  isTeams: z.boolean(),
  isPhone: z.boolean(),
  phoneNumber: z.string().nullable(),
  isAskInvitee: z.boolean(),
  isCustom: z.boolean(),
  customLocation: z.string().nullable(),
});

export const toListItem = (
  eventTypeLocation: EventTypeLocation,
): EventTypeLocationListItem => {
  return {
    eventTypeId: Number(eventTypeLocation.eventTypeId),
    isInPerson: eventTypeLocation.isInPerson,
    address: eventTypeLocation.address,
    isZoom: eventTypeLocation.isZoom,
    isGoogle: eventTypeLocation.isGoogle,
    isTeams: eventTypeLocation.isTeams,
    isPhone: eventTypeLocation.isPhone,
    phoneNumber: eventTypeLocation.phoneNumber,
    isAskInvitee: eventTypeLocation.isAskInvitee,
    isCustom: eventTypeLocation.isCustom,
    customLocation: eventTypeLocation.customLocation,
  };
};

export const toItem = (
  eventTypeLocation: EventTypeLocation,
): EventTypeLocationItem => {
  return {
    eventTypeId: Number(eventTypeLocation.eventTypeId),
    displayType: eventTypeLocation.displayType,
    isInPerson: eventTypeLocation.isInPerson,
    access: eventTypeLocation.access,
    address: eventTypeLocation.address,
    isZoom: eventTypeLocation.isZoom,
    isGoogle: eventTypeLocation.isGoogle,
    isTeams: eventTypeLocation.isTeams,
    isPhone: eventTypeLocation.isPhone,
    phoneNumber: eventTypeLocation.phoneNumber,
    phoneNumberCountryCode: eventTypeLocation.phoneNumberCountryCode,
    phoneType: eventTypeLocation.phoneType,
    isAskInvitee: eventTypeLocation.isAskInvitee,
    isCustom: eventTypeLocation.isCustom,
    customLocation: eventTypeLocation.customLocation,
    sort: eventTypeLocation.sort,
    zoomDisconnectedUserId: eventTypeLocation.zoomDisconnectedUserId,
    googleDisconnectedUserId: eventTypeLocation.googleDisconnectedUserId,
  };
};
